namespace app.view{

	import Pinpoint = app.model.Pinpoint;
	import Weekly = app.model.Weekly;
	export class PinpointView{
		public pinpoint:Pinpoint;
		public weekly:Weekly;

		constructor(){

		}

		private getLocationName():string{
			return this.pinpoint.data.name;
		}

		private getCreateTime():string{
			return this.pinpoint.data.createDate.toString(Const.DATE_PINPOINT_CREATION);
		}

		private getTodayDate(i):string{
			return this.pinpoint.data.items[i].date.toString(Const.DATE_DEFAULT);
		}

		private getTodayTime(i):string{
			return this.pinpoint.data.items[i].date.toString(Const.TIME_DEFAULT);
		}
		private getTodayWeather(i):string{
			return this.pinpoint.data.items[i].weather.toString();
		}
		private getTodayPrec(i):string{
			return this.pinpoint.data.items[i].prec.toString();
		}
		private getTodayPop(i):string{
			return this.pinpoint.data.items[i].pop.toString();
		}
		private getTodayTemp(i):string{
			return this.pinpoint.data.items[i].temp.toString();
		}
		private getWeeklyDate(i):string{
			return this.weekly.data.items[i].date.toString(Const.DATE_DEFAULT);
		}
		private getWeeklyWeather(i):string{
			let str = this.weekly.data.items[i].weather;
			return `${str}_0/${str}_0_0001`;
		}
		private getWeeklyTMax(i):string{
			return this.weekly.data.items[i].tmax.toString();
		}
		private getWeeklyTMin(i):string{
			return this.weekly.data.items[i].tmin.toString();
		}
		private getWeeklyPop(i):string{
			return this.weekly.data.items[i].pop.toString();
		}


		public makeData():string{
			let result:string = this.renderPinpoint() + this.renderWeekly();
			return result;
		}

		public makeError():string{
			let str = `<p>データの取得に失敗しました</p>`;
			return str;
		}

		private renderPinpoint():string{
			let result = `
<div class="today">
            <h2><span class="location">${this.getLocationName()}</span><span class="info">${this.getCreateTime()}</span></h2>
			<table>
              <tr>
                <th>日付</th>
                <td>${this.getTodayDate(0)}</td>
                <td>${this.getTodayDate(1)}</td>
                <td>${this.getTodayDate(2)}</td>
                <td>${this.getTodayDate(3)}</td>
                <td>${this.getTodayDate(4)}</td>
                <td>${this.getTodayDate(5)}</td>
                <td>${this.getTodayDate(6)}</td>
                <td>${this.getTodayDate(7)}</td>
              </tr>
              <tr>
                <th>時刻</th>
                <td>${this.getTodayTime(0)}</td>
                <td>${this.getTodayTime(1)}</td>
                <td>${this.getTodayTime(2)}</td>
                <td>${this.getTodayTime(3)}</td>
                <td>${this.getTodayTime(4)}</td>
                <td>${this.getTodayTime(5)}</td>
                <td>${this.getTodayTime(6)}</td>
                <td>${this.getTodayTime(7)}</td>
              </tr>
              <tr>
                <th>天気</th>
                <td><img src="img/p_img/${this.getTodayWeather(0)}.gif"></td>
                <td><img src="img/p_img/${this.getTodayWeather(1)}.gif"></td>
                <td><img src="img/p_img/${this.getTodayWeather(2)}.gif"></td>
                <td><img src="img/p_img/${this.getTodayWeather(3)}.gif"></td>
                <td><img src="img/p_img/${this.getTodayWeather(4)}.gif"></td>
                <td><img src="img/p_img/${this.getTodayWeather(5)}.gif"></td>
                <td><img src="img/p_img/${this.getTodayWeather(6)}.gif"></td>
                <td><img src="img/p_img/${this.getTodayWeather(7)}.gif"></td>
              </tr>
              <tr>
                <th>降水量</th>
                <td>${this.getTodayPrec(0)}mm/h</td>
                <td>${this.getTodayPrec(1)}mm/h</td>
                <td>${this.getTodayPrec(2)}mm/h</td>
                <td>${this.getTodayPrec(3)}mm/h</td>
                <td>${this.getTodayPrec(4)}mm/h</td>
                <td>${this.getTodayPrec(5)}mm/h</td>
                <td>${this.getTodayPrec(6)}mm/h</td>
                <td>${this.getTodayPrec(7)}mm/h</td>
              </tr>
              <tr>
                <th>降水確率</th>
                <td>${this.getTodayPop(0)}%</td>
                <td>${this.getTodayPop(1)}%</td>
                <td>${this.getTodayPop(2)}%</td>
                <td>${this.getTodayPop(3)}%</td>
                <td>${this.getTodayPop(4)}%</td>
                <td>${this.getTodayPop(5)}%</td>
                <td>${this.getTodayPop(6)}%</td>
                <td>${this.getTodayPop(7)}%</td>
              </tr>
              <tr>
                <th>気温</th>
                <td>${this.getTodayTemp(0)}℃</td>
                <td>${this.getTodayTemp(1)}℃</td>
                <td>${this.getTodayTemp(2)}℃</td>
                <td>${this.getTodayTemp(3)}℃</td>
                <td>${this.getTodayTemp(4)}℃</td>
                <td>${this.getTodayTemp(5)}℃</td>
                <td>${this.getTodayTemp(6)}℃</td>
                <td>${this.getTodayTemp(7)}℃</td>
              </tr>
            </table>
          </div>
          
        </div>
`;

			return result;
		}

		private renderWeekly():string{
			if(!this.weekly.data){
				return '';
			}

			let result:string =`
			<div class="weekly">
            <h2>週間予報</h2>
            <table>
              <tr>
                <th>日付</th>
                <td>${this.getWeeklyDate(0)}</td>
                <td>${this.getWeeklyDate(1)}</td>
                <td>${this.getWeeklyDate(2)}</td>
                <td>${this.getWeeklyDate(3)}</td>
                <td>${this.getWeeklyDate(4)}</td>
                <td>${this.getWeeklyDate(5)}</td>
                <td>${this.getWeeklyDate(6)}</td>
              </tr>
              <tr>
                <th>天気</th>
                <td><img src="img/w_img/${this.getWeeklyWeather(0)}.gif"></td>
                <td><img src="img/w_img/${this.getWeeklyWeather(1)}.gif"></td>
                <td><img src="img/w_img/${this.getWeeklyWeather(2)}.gif"></td>
                <td><img src="img/w_img/${this.getWeeklyWeather(3)}.gif"></td>
                <td><img src="img/w_img/${this.getWeeklyWeather(4)}.gif"></td>
                <td><img src="img/w_img/${this.getWeeklyWeather(5)}.gif"></td>
                <td><img src="img/w_img/${this.getWeeklyWeather(6)}.gif"></td>
              </tr>
              <tr>
                <th>気温</th>
                <td><span class="max">${this.getWeeklyTMax(0)}℃</span><span class="divide">/</span><span class="min">${this.getWeeklyTMin(0)}℃</span></td>
                <td><span class="max">${this.getWeeklyTMax(1)}℃</span><span class="divide">/</span><span class="min">${this.getWeeklyTMin(1)}℃</span></td>
                <td><span class="max">${this.getWeeklyTMax(2)}℃</span><span class="divide">/</span><span class="min">${this.getWeeklyTMin(2)}℃</span></td>
                <td><span class="max">${this.getWeeklyTMax(3)}℃</span><span class="divide">/</span><span class="min">${this.getWeeklyTMin(3)}℃</span></td>
                <td><span class="max">${this.getWeeklyTMax(4)}℃</span><span class="divide">/</span><span class="min">${this.getWeeklyTMin(4)}℃</span></td>
                <td><span class="max">${this.getWeeklyTMax(5)}℃</span><span class="divide">/</span><span class="min">${this.getWeeklyTMin(5)}℃</span></td>
                <td><span class="max">${this.getWeeklyTMax(6)}℃</span><span class="divide">/</span><span class="min">${this.getWeeklyTMin(6)}℃</span></td>
              </tr>
              <tr>
                <th>降水確率</th>
                <td>${this.getWeeklyPop(0)}%</td>
                <td>${this.getWeeklyPop(1)}%</td>
                <td>${this.getWeeklyPop(2)}%</td>
                <td>${this.getWeeklyPop(3)}%</td>
                <td>${this.getWeeklyPop(4)}%</td>
                <td>${this.getWeeklyPop(5)}%</td>
                <td>${this.getWeeklyPop(6)}%</td>
              </tr>
            </table>
          </div>
`;
			return result
		}

	}

}

